import { call, put, takeLatest } from 'redux-saga/effects';

import getDocumentsAPI from '../../api/get-documents';
import postDocumentsAPI from '../../api/post-documents';
import {
  receiveDocuments,
  receivePostDocuments,
  rejectDocuments,
  rejectPostDocuments,
  requestDocuments,
  requestPostDocuments,
} from '../actions/admin-page';

interface IPostDocumentsAction {
  type: string;
  payload: {
    documentPD: File | null;
    documentIT: File | null;
    documentRP: File | null;
    documentRU: File | null;
  };
}

const getDocuments = function* getDocuments() {
  try {
    const response: Awaited<ReturnType<typeof getDocumentsAPI>> = yield call(getDocumentsAPI);
    yield put(receiveDocuments(response));
  } catch (error) {
    yield put(rejectDocuments({ error }));
  }
};

const postDocuments = function* postDocuments(action: IPostDocumentsAction) {
  try {
    yield call(postDocumentsAPI, { documents: action.payload });
    yield put(receivePostDocuments());
    yield put(requestDocuments());
  } catch (error) {
    yield put(rejectPostDocuments({ error }));
  }
};

export default function* documentsWatcher() {
  yield takeLatest(requestDocuments, getDocuments);
  yield takeLatest(requestPostDocuments, postDocuments);
}
